<template>
  <div>
    <v-toolbar :flat="flat" :dense="dense" :dark="!light" :color="color ? color : 'secondary'">
      <slot name="title">
        <v-toolbar-title v-html="title" />
      </slot>
      <v-spacer />
      <v-text-field v-if="search" class="mt-2 emphasize-clear" @click:clear="clearSearch()" :class="{ 'rounded': rounded }" :dark="!lightSearch" append-icon="search" :label="`Search ${ search ? search.toLowerCase() : '' }`" v-on="$listeners" autofocus clearable :value="value" :loading="loading" :color="lightSearch ? '' : 'white'" :hint="hint" solo>
        <template v-if="$slots.tooltip" #append>
          <slot name="tooltip" />
          <v-icon class="ml-2">search</v-icon>
        </template>
      </v-text-field>
      <!-- <v-spacer v-if="!title" /> -->
      <slot name="actions" />
    </v-toolbar>
    <transition name="fade">
      <v-toolbar v-if="$slots.default" :flat="flat" dark :color="secondaryColor ? secondaryColor : 'tertiary'" dense>
        <slot />
      </v-toolbar>
    </transition>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      value: String,
      title: String,
      loading: Boolean,
      search: String,
      color: String,
      light: Boolean,
      lightSearch: Boolean,
      secondaryColor: String,
      dense: Boolean,
      hint: String,
      rounded: Boolean,
      flat: Boolean,
    },
    methods: {
      clearSearch() {
        this.$emit('input', '')
      },
    },
  }
</script>